/* eslint-disable prefer-arrow/prefer-arrow-functions */
/* eslint-disable @typescript-eslint/naming-convention */


  export interface LogElencoArticoli {
      log_ean: any;
      log_qta: number;
      log_titolo: string;
      log_ReturnStatus: string;
      log_nota: string;
  }

  export interface DatiRord {
      annotazione: string;
      ReturnStatus: string;
      FileStatus: string;
      ReturnMessage: string;
      log_elencoArticoli: LogElencoArticoli[];
      log_numeroordine: number;
  }

  export interface Response {
      datiRord: DatiRord;
  }

  export interface DSCReponce {
      Response: Response;
  }

    export interface RowOrdine {
      id: number | null;
      codice: string;
      nr_causale: string;
      nr_ordine: string;
      riferimento: string;
      cod_agente: string;
      nr_riga: string;
      cod_articolo: string;
      ean: string;
      stato: string;
      stato_articolo: string;
      novita: string;
      cod_cliente: string;
      ragione_sociale: string;
      titolo: string;
      qta_in_spedizione: string;
      rimanenza: string;
      prezzo: string;
      sconto_base: string;
      sc1: string;
      sc2: string;
      sc3: string;
      sconto: string;
      defiscalizzato?: any;
      valore_rimanenza: string;
      data_ordine: string;
      editore: string;
      autore?: any;
      causale_ordine: string;
      aliquota: string;
      righe?: Array<RowOrdine>;
      totale?: number;
      budget_qta?: string;
      cedola?: string;
      codice_cedola?: string;
      data_cedola?: string;
  }


export function getQuantita(ordini: Array<RowOrdine>) {
  let in_spedizione = 0;
  let rimanenza     = 0;
  if (ordini && ordini.length) {
  ordini.forEach((data: RowOrdine) => {
    in_spedizione = in_spedizione + Number(data.qta_in_spedizione);
    rimanenza = rimanenza+Number(data.rimanenza);
  });
}
  return `${in_spedizione} / ${rimanenza}`;
}



export function getPrenotazioni(prenotazioni: Array<RowOrdine>) {
  let rimanenza     = 0;
  if (prenotazioni && prenotazioni.length) {
    prenotazioni.forEach((data: RowOrdine) => {
      rimanenza = rimanenza+Number(data.rimanenza);
    });
  }

  return `${rimanenza}`;
}
